<template>
  <div id="submit-course">
    <dash-header
      :pages="breadCrumbsPages"
      :dashboardTitle="'Submit Course'"
      v-if="this.$router.currentRoute.name !== 'dashboard'"
    />
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="4"
        :menuItems="commonMenuItems.admin"
        v-if="
          this.$router.currentRoute.name !== 'dashboard' &&
          userRole === 'telas_telas_administrator'
        "
      />
      <dash-sidebar
        defaultSelectedKeys="4"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="
          this.$router.currentRoute.name !== 'dashboard' &&
          userRole === 'telas_course_submitters'
        "
      />
      <a-layout-content
        :style="{
          margin: '24px 16px',
          padding: '24px',
          background: '#fff',
          minHeight: '280px',
        }"
      >
        <a-alert v-if="successMessage" type="success" :message="successMessage" banner />
        <br />
        <a-form
          id="submit-course"
          :form="submitCourseForm"
          class="submit-course"
          @submit="handleSubmitCourse"
        >
          <a-form-item v-bind="formItemLayout" label="Course Submission Date">
            <a-date-picker
              format="DD/MM/YYYY"
              v-decorator="[
                'courseSubmissionDate',
                { rules: [{ required: true, message: 'Please select a valid Date.' }] },
              ]"
              @change="handleDateChange"
            >
            </a-date-picker>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course Submitter Name">
            <a-input
              v-decorator="[
                'courseSubmitterName',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter the Course Submitter Name.',
                    },
                  ],
                  initialValue: userName,
                },
              ]"
              placeholder="Course Submitter Name"
              disabled
            >
            </a-input>
            <a-input
              v-decorator="[
                'courseSubmitterId',
                {
                  rules: [{ required: true, message: '' }],
                  initialValue: currentUserId,
                },
              ]"
              hidden="true"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course Name">
            <a-input
              v-decorator="[
                'coursePackageName',
                { rules: [{ required: true, message: 'Please enter the Course Name.' }] },
              ]"
              placeholder="Course Name"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course Package Type">
            <a-input
              v-decorator="[
                'coursePackageType',
                { rules: [{ required: true, message: 'Please enter the Course Type.' }] },
              ]"
              placeholder="Course Package Type"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course Package Identifier">
            <a-input
              v-decorator="[
                'coursePackageIdentifier',
                {
                  rules: [
                    { required: true, message: 'Please enter the Course Identifier.' },
                  ],
                },
              ]"
              placeholder="Course Package Identifier"
            >
            </a-input>
          </a-form-item>
          <!-- <a-form-item
              v-bind="formItemLayout"
              label="Course Module Name">
              <a-input
                  v-decorator="[
                    'courseModuleName',
                    { rules: [{ required: true, message: 'Please enter the Course Module Name.' }] }
                  ]"
                  placeholder="Course Module Name"
                >
              </a-input>
            </a-form-item> -->
          <!-- <a-form-item
              v-bind="formItemLayout"
              label="New or Exisiting Course">
                <a-radio-group defaultValue="new" buttonStyle="solid">
                  <a-radio-button value="new">New</a-radio-button>
                  <a-radio-button value="existing">Existing</a-radio-button>
                </a-radio-group>
            </a-form-item> -->
          <a-form-item v-bind="formItemLayout" label="Course Module Identifier">
            <a-input
              v-decorator="[
                'courseModuleIdentifier',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter the Course module identifier',
                    },
                  ],
                },
              ]"
              placeholder="Course module identifier"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">
              Study Area&nbsp;
              <a-tooltip title="e.g. engineering, medical, etc.">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
            <a-input
              v-decorator="[
                'studyLevel',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter the Study Area',
                    },
                  ],
                },
              ]"
              placeholder="Study Area"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course Level">
            <a-select
              placeholder="Course Level"
              style="width: 100%"
              :filterOption="false"
              v-decorator="[
                'courseLevel',
                {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please select one option.' }],
                },
              ]"
            >
              <a-select-option value="">Select One</a-select-option>
              <a-select-option value="Undergraduate">Undergraduate</a-select-option>
              <a-select-option value="Postgraduate">Postgraduate</a-select-option>
              <a-select-option value="Universal">Universal</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Institution name">
            <a-input
              v-decorator="[
                'institutionName',
                {
                  rules: [
                    { required: true, message: 'Please enter the Institution name' },
                  ],
                },
              ]"
              placeholder="Institution name"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Faculty / Dept">
            <a-input
              v-decorator="[
                'facultyDept',
                {
                  rules: [{ required: true, message: 'Please enter the Faculty / Dept' }],
                },
              ]"
              placeholder="Faculty / Dept"
            >
            </a-input>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">
              Submit for Accreditation&nbsp;
              <a-tooltip
                title="Receive Assessment Report only or Accreditation Certificate & Badge with Assessment Report."
              >
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
            <a-select
              placeholder="Submit for Accreditation"
              style="width: 100%"
              :filterOption="false"
              v-decorator="[
                'submitForAccreditation',
                {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please select one option.' }],
                },
              ]"
            >
              <a-select-option value="">Select One</a-select-option>
              <a-select-option value="Formal accreditation"
                >Formal accreditation</a-select-option
              >
              <a-select-option value="Summary report only"
                >Summary report only</a-select-option
              >
              <a-select-option value="Undecided">Undecided</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course enrollment contact">
            <a-input-group size="default" :compact="true">
              <a-row :gutter="5">
                <a-col :span="8">
                  <a-input v-decorator="['enrollerName']" placeholder="Name" />
                </a-col>
                <a-col :span="8">
                  <a-input
                    v-decorator="[
                      'enrollerEmail',
                      {
                        rules: [
                          {
                            type: 'email',
                            message: 'Please enter your valid Email Address',
                          },
                        ],
                      },
                    ]"
                    placeholder="E-mail"
                  />
                </a-col>
                <a-col :span="8">
                  <a-input v-decorator="['enrollerPhone']" placeholder="Phone" />
                </a-col>
              </a-row>
            </a-input-group>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Course Framework">
            <a-select
              v-decorator="[
                'frameworkId',
                {
                  initialValue: defaultFrameworkId,
                  rules: [{ required: true, message: 'Please select a framework.' }],
                },
              ]"
              placeholder="Select a Framework"
              style="width: 100%"
            >
              <a-select-option
                v-for="framework in frameworks"
                :key="framework.id"
                :value="framework.id"
              >
                {{ framework.title.rendered }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            v-if="userRole === 'telas_telas_administrator'"
            v-bind="formItemLayout"
            label="For Test"
          >
            <a-radio-group
              style="width: 100%"
              v-decorator="[
                'forTest',
                {
                  initialValue: 'no',
                  rules: [{ required: false, message: 'Please select one option.' }],
                },
              ]"
            >
              <a-radio-button value="yes">Yes</a-radio-button>
              <a-radio-button value="no">No</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-bind="tailFormItemLayout">
            <a-button type="primary" html-type="submit" class="Submit"> Submit </a-button>
          </a-form-item>
        </a-form>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
/* eslint-disable no-param-reassign */
import { mapActions, mapGetters, mapState } from "vuex";
import dashHeader from "../dashboard/Header.vue";
import dashSidebar from "../dashboard/Sidebar.vue";

export default {
  name: "submit-course",
  components: {
    dashHeader,
    dashSidebar,
  },
  data() {
    return {
      courseSubmissionDate: "",
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 16 },
          sm: { span: 8 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 8,
            offset: 8,
          },
        },
      },
      breadCrumbsPages: [
        {
          name: "Home",
          route: "/",
        },
        {
          name: "Dashboard",
          route: "/dashboard",
        },
        {
          name: "Submit Course",
          route: "/dashboard/submit-course",
        },
      ],
      dashboardTitle: "",
      successMessage: false,
    };
  },
  computed: {
    ...mapGetters("user", {
      userToken: "getUserToken",
      userRole: "getUserRole",
      currentUserId: "getUserId",
    }),
    ...mapGetters("dashboard", {
      userProfileDetails: "getUserProfileDetails",
    }),
    ...mapState("user", {
      userName: (state) => state.userDetails.user_display_name,
    }),
    ...mapState("dashboard", {
      userID: (state) => state.userDetails.user_id,
      userCourses: (state) => state.courses,
    }),
    ...mapState("frameworks", {
      frameworks: (state) => state.frameworks,
    }),
  },
  beforeCreate() {
    this.submitCourseForm = this.$form.createForm(this);
  },
  methods: {
    ...mapActions("courses", {
      submitCourse: "submitCourse",
    }),
    handleDateChange(date, dateString) {
      this.courseSubmissionDate = dateString;
    },
    handleSubmitCourse(e) {
      e.preventDefault();
      this.submitCourseForm.validateFields((err, values) => {
        if (!err) {
          values.forTest = values.forTest === undefined ? "no" : values.forTest;
          values.userToken = this.userToken;
          values.courseSubmitterId = this.currentUserId;
          values.courseSubmissionDateString = this.courseSubmissionDate;
          this.submitCourse(values);
        }
      });
    },
    ...mapActions("dashboard", {
      getCoursesByUser: "getCoursesByUser",
    }),
  },
  created() {
    this.$store.dispatch("frameworks/fetchFrameworks");
    const standardFramework = this.frameworks.find(
      (framework) => framework.title.rendered === "Standard"
    );
    console.log(standardFramework);
    if (standardFramework) {
      this.defaultFrameworkId = standardFramework.id;
      console.log(this.defaultFrameworkId);
    }
    this.$store.subscribe((mutation) => {
      if (mutation.type === "courses/COURSESUBMITTED") {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.successMessage = "You have successfully submitted the course.";
        if (this.$router.currentRoute.name === "dashboard") {
          const getAllCoursesArgs = {
            status: "publish",
            role: "institution",
            userToken: this.userToken,
            author_exclude: this.userID,
            "filter[meta_key]": "institutionName",
            "filter[meta_compare]": "=",
            "filter[meta_value]": this.userProfileDetails.institution_name,
          };
          const userApprovedCoursesArgs = {
            status: "publish",
            author: this.userID,
            role: this.userRole,
          };
          this.getCoursesByUser(getAllCoursesArgs);
          this.getCoursesByUser(userApprovedCoursesArgs);
          this.$emit("submittedCourse");
        } else {
          setTimeout(() => {
            this.$router.push("/dashboard", () => {});
            this.$emit("submittedCourse");
          }, 1000);
        }
        this.submitCourseForm.resetFields();
        setTimeout(() => {
          this.successMessage = "";
        }, 2000);
      }
    });
  },
  mounted() {},
};
</script>
